export default {
	home:
		{
			login_success: '登录成功!',
		},
};
